// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ` /*
 Copyright (c) 2023 Quantellia LLC
 All Rights Reserved
 */
.node-edit-modal {
  display: none; /* Start with the modal hidden */
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background-color: #f9f9f9;
  border: 1px solid #ccc;
  padding: 20px;
  z-index: 1000;
  cursor: move; /* Add cursor style for dragging */
}

  /* Styles for the modal button/icon */
  .node-edit-modal-button {
    display:none; 
    position: absolute;
    top: 10px;
    right: 10px;
    background-color: #007bff;
    color: #fff;
    border: none;
    padding: 5px 10px;
    border-radius: 5px;
    cursor: pointer;
  }
`, "",{"version":3,"sources":["webpack://./css/node-editor.css"],"names":[],"mappings":"CAAC;;;EAGC;AACF;EACE,aAAa,EAAE,gCAAgC;EAC/C,eAAe;EACf,QAAQ;EACR,SAAS;EACT,gCAAgC;EAChC,yBAAyB;EACzB,sBAAsB;EACtB,aAAa;EACb,aAAa;EACb,YAAY,EAAE,kCAAkC;AAClD;;EAEE,qCAAqC;EACrC;IACE,YAAY;IACZ,kBAAkB;IAClB,SAAS;IACT,WAAW;IACX,yBAAyB;IACzB,WAAW;IACX,YAAY;IACZ,iBAAiB;IACjB,kBAAkB;IAClB,eAAe;EACjB","sourcesContent":[" /*\r\n Copyright (c) 2023 Quantellia LLC\r\n All Rights Reserved\r\n */\r\n.node-edit-modal {\r\n  display: none; /* Start with the modal hidden */\r\n  position: fixed;\r\n  top: 50%;\r\n  left: 50%;\r\n  transform: translate(-50%, -50%);\r\n  background-color: #f9f9f9;\r\n  border: 1px solid #ccc;\r\n  padding: 20px;\r\n  z-index: 1000;\r\n  cursor: move; /* Add cursor style for dragging */\r\n}\r\n\r\n  /* Styles for the modal button/icon */\r\n  .node-edit-modal-button {\r\n    display:none; \r\n    position: absolute;\r\n    top: 10px;\r\n    right: 10px;\r\n    background-color: #007bff;\r\n    color: #fff;\r\n    border: none;\r\n    padding: 5px 10px;\r\n    border-radius: 5px;\r\n    cursor: pointer;\r\n  }\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
